module.exports = __webpack_public_path__ + "static/img/BL712.02abce8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/psLock/712/BL712.jpg
// module id = /k7w
// module chunks = 0